import { reflect } from '@effector/reflect'

import { YahooButton as View } from '../view'
import * as model from './model'

export const YahooPairButton = reflect({
    view: View,
    bind: {
        onClick: model.yahooPairButtonClicked,
    },
})
